<div>
    <ntv-button
        (buttonClick)="filterByPopover.toggle($event)"
        color="custom"
        customColor="#8DCB2C"
        size="xl"
        rounded="md">
        <div class="main-btn text-white">
            <svg width="14" height="14">
                <use xlink:href="assets/icons/icons-sprite.svg#filter"></use>
            </svg>
            @if (showLabel()) {
                <span>Filter by</span>
            }
            @if (selectedCount() > 0) {
                <span class="main-btn__count">{{ selectedCount() }}</span>
            }
        </div>
    </ntv-button>

    <ntv-popover #filterByPopover>
        <div
            class="popover"
            [class.popover--grouped]="type() === 'grouped'"
            [style.max-height.px]="maxHeight()">
            @if (type() === 'default') {
                @for (option of dropdownOptions(); track $index) {
                    <div
                        class="popover__item"
                        role="button"
                        tabindex="0"
                        (click)="onOptionClick(option); filterByPopover.hide()">
                        @if (option.icon) {
                            <svg class="popover__icon" width="16" height="16">
                                <use
                                    [attr.xlink:href]="
                                        'assets/icons/icons-sprite.svg#' + option.icon
                                    "></use>
                            </svg>
                        }
                        <span>{{ option.label }}</span>
                    </div>
                }
            } @else if (type() === 'grouped') {
                @for (group of groupedOptions(); track group.id || $index) {
                    <div class="popover__group">
                        <div class="popover__item" [class.popover__item--active]="group.checked">
                            <span class="popover__label" (click)="onGroupToggle(group)">{{
                                group.label
                            }}</span>
                            @if (group.children?.length) {
                                <button
                                    class="popover__toggle"
                                    (click)="onGroupToggle(group); $event.stopPropagation()">
                                    @if (group.expanded) {
                                        <span class="popover__toggle-icon">—</span>
                                    } @else {
                                        <span class="popover__toggle-icon">+</span>
                                    }
                                </button>
                            }
                        </div>

                        @if (group.expanded && group.children?.length) {
                            <div class="popover__children">
                                <ng-container
                                    *ngTemplateOutlet="
                                        treeNodeTmpl;
                                        context: { $implicit: group.children }
                                    "></ng-container>
                            </div>
                        }
                    </div>
                }
            }
        </div>
    </ntv-popover>

    <ng-template #treeNodeTmpl let-nodes>
        <div class="popover__group">
            @for (node of nodes; track node.id || $index) {
                <div class="popover__tree-item">
                    <div class="popover__item" [class.popover__item--active]="node.checked">
                        @if (!node.children?.length) {
                            <ntv-checkbox
                                size="sm"
                                [label]="node.label"
                                [checked]="!!node.checked"
                                [indeterminate]="!!node.indeterminate"
                                (checkedChange)="onTreeCheckedChange(node, $event)">
                            </ntv-checkbox>
                        } @else {
                            <span class="popover__label">{{ node.label }}</span>
                        }
                        @if (node.children?.length) {
                            <button
                                class="popover__toggle"
                                (click)="onTreeExpandToggle(node, $event)">
                                @if (node.expanded) {
                                    <span class="popover__toggle-icon">—</span>
                                } @else {
                                    <span class="popover__toggle-icon">+</span>
                                }
                            </button>
                        }
                    </div>
                    @if (node.expanded && node.children?.length) {
                        <div class="popover__children">
                            <ng-container
                                *ngTemplateOutlet="
                                    treeNodeTmpl;
                                    context: { $implicit: node.children }
                                "></ng-container>
                        </div>
                    }
                </div>
            }
        </div>
    </ng-template>
</div>
